"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class Payment {
    static fromObj(data) {
        if (data) {
            const { type } = data;
            if (type === __1.ePaymentType.INVOICE) {
                return new __1.InvoicePayment();
            }
            if ([__1.ePaymentType.CREDIT_CARD, "STORED_CC", "NEW_CC"].includes(type)) {
                const { transactionId, processor } = data;
                return new __1.CreditCardPayment(processor, transactionId);
            }
        }
        return new __1.UnknownPayment();
    }
}
exports.default = Payment;
//# sourceMappingURL=payment.class.js.map